import { useNavigate } from "react-router-dom";
import { Heart } from "lucide-react";
import { toast } from "sonner";
import { errMsg } from "@/lib/api";
import { useSaved } from "@/lib/shopper";

export const SaveButton = ({ deal, className = "", label = false }) => {
  const { isSignedIn, ids, toggle, busy } = useSaved();
  const navigate = useNavigate();
  const saved = ids.has(deal.id);
  const onClick = async (e) => {
    e.preventDefault();
    e.stopPropagation();
    if (!isSignedIn) {
      toast("Sign in with Google to save deals");
      return navigate("/sign-in");
    }
    try { toast.success((await toggle(deal.id)) ? "Saved to your account" : "Removed from saved"); }
    catch (er) { toast.error(errMsg(er)); }
  };
  return (
    <button onClick={onClick} disabled={busy} aria-pressed={saved} aria-label={saved ? "Remove from saved" : "Save deal"} data-testid={`save-deal-${deal.id}`}
      className={`inline-flex items-center gap-1.5 rounded-full transition-[background-color,transform] active:scale-90 ${label ? "border border-slate-300 px-4 py-2 font-semibold hover:bg-slate-50" : "h-9 w-9 justify-center bg-white/90 shadow hover:bg-white"} ${className}`}>
      <Heart size={label ? 16 : 18} className={saved ? "fill-red-500 text-red-500" : "text-slate-600"} />
      {label && (saved ? "Saved" : "Save")}
    </button>
  );
};
